import { render, staticRenderFns } from "./DetallesLote.vue?vue&type=template&id=3272ceaa&"
import script from "./DetallesLote.vue?vue&type=script&lang=js&"
export * from "./DetallesLote.vue?vue&type=script&lang=js&"
import style0 from "./DetallesLote.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports